import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { AccessPointComponent } from './components/admin/access-point/access-point.component';
import { BuildingScanComponent } from './components/admin/building-scan/building-scan.component';
import { FileUploadPageComponent } from './components/file-upload-page/file-upload-page.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/side-nav/logout/logout.component';
import { EntryGuard } from './core/auth/entry.guard';
import { AVAILABLE_LANGUAGES } from './core/models/languages.model';

export const routes: Routes = [
  { path: '', redirectTo: 'en', pathMatch: 'full' },
  ...AVAILABLE_LANGUAGES.map(
    (language): Route => ({
      path: `${language}`,
      canMatch: [() => EntryGuard()],
      children: [
        { path: 'home', component: HomeComponent },
        { path: 'admin/access-point', component: AccessPointComponent },
        { path: 'admin/building-scan', component: BuildingScanComponent },
        {
          path: 'admin',
          loadChildren: () =>
            import('./components/admin/admin.module').then(
              (m) => m.AdminModule,
            ),
        },
        {
          path: 'operations',
          loadChildren: () =>
            import('./components/operations/operations.module').then(
              (m) => m.OperationsModule,
            ),
        },
        {
          path: 'exceptions',
          loadChildren: () =>
            import('./components/exceptions/exceptions.module').then(
              (m) => m.ExceptionsModule,
            ),
        },
        {
          path: 'reports',
          loadChildren: () =>
            import('./components/reports/reports.module').then(
              (m) => m.ReportsModule,
            ),
        },
        { path: 'file-upload', component: FileUploadPageComponent },
        { path: 'auth', component: MsalRedirectComponent },
        { path: '', pathMatch: 'full', redirectTo: 'home' },
        { path: '**', redirectTo: 'home' },
      ],
    }),
  ),
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'auth', component: MsalRedirectComponent },
  { path: '**', redirectTo: 'en' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
